import React from "react"
import PropTypes from "prop-types"
import BlockContent from "components/BlockContent"
import theme from "styles/theme"
import Link from "components/Link"

// Fairly standard BlockContent with typical text styles
const TextBlock = ({ serializers = {}, ...props }) => (
  <BlockContent
    css={{
      ...theme.bodyCopy,
      color: theme.textGray,
      h2: {
        ...theme.t4,
        margin: "3.17em 0 0.75em",
      },
      [["ol", "ul"]]: {
        margin: "0 0 0 1.75em",
        paddingLeft: "1em",
        [theme.mobile]: { marginLeft: 10, marginRight: 0 },
      },
      li: {
        margin: "1em 0",
      },
      a: {
        textDecoration: "underline",
        transition: "color 250ms",
        ":hover": {
          color: theme.midBlue,
        },
      },
    }}
    serializers={{
      ...serializers,
      marks: {
        link: linkSerializer,
        ...(serializers.marks || {}),
      },
    }}
    {...props}
  />
)

export default TextBlock

TextBlock.propTypes = {
  serializers: PropTypes.object,
}

const linkSerializer = ({ mark: { href }, children }) => (
  <Link href={href}>{children}</Link>
)
linkSerializer.propTypes = {
  mark: PropTypes.shape({
    href: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
}
